module.exports = __webpack_public_path__ + "img/Mario Havel.2e8fcc7a.jpg";